import { Kursteilnehmer } from "./teilnehmer";
//import { TeilnehmerService } from "../_services/teilnehmer.service";

export class Kurs
{
  constructor(_knr: number, _kursName: string, _ort: string, _kursbeginn?: string, _kursende?: string)
  {
    this.kursName = _kursName;
    this.kursNr = _knr;
    this.ort = _ort;
    this.kursEnde = _kursende;
    this.kursbeginn = _kursbeginn;


  }
  kursNr: number;
  kursName: string;
  ort: string;
  kursEnde?: string;
  teilnehmer: Kursteilnehmer[];
  kursbeginn: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/kurs.ts